import { pollLine } from '../brief-copy.ts';

/** A poll as the Brief stores it: the question, who answered it, and each option's count. */
export interface PollCounts {
  question_text: string;
  respondents: number;
  options: readonly { option_id: string; text: string; count: number }[];
}

/**
 * One bar per option, in the guide's order, each with its label and its count of the people who
 * answered. Every number is the stored one; the bar's width is only those two numbers drawn.
 */
export const PollBar = ({ poll }: { poll: PollCounts }) => (
  <figure className="brief-poll" data-test-id="brief-poll">
    <figcaption className="brief-poll-question">{poll.question_text}</figcaption>
    <ul className="brief-bars">
      {poll.options.map((option) => (
        <li key={option.option_id} data-test-id="brief-poll-option">
          <span className="brief-bar-label" data-test-id="brief-poll-label">
            {option.text}
          </span>
          <span className="brief-bar-track" aria-hidden="true">
            <span
              className="brief-bar"
              style={{
                width: `${String(poll.respondents === 0 ? 0 : (option.count / poll.respondents) * 100)}%`,
              }}
            />
          </span>
          <span className="brief-meta" data-test-id="brief-poll-line">
            {pollLine(option.count, poll.respondents)}
          </span>
        </li>
      ))}
    </ul>
  </figure>
);
